import angular from 'angular';

import List from './list.component';

import './list.component.scss';


export default angular
  .module('petroCloud.admin.list', [])
  .component(List.name, List)
  .name;

